import PrivateRoute from 'utils/privateRoute';

import Workspace from 'components/DatabricksADB/workspace';
import JobsADB from 'components/DatabricksADB/JobsADB';
import ClusterAnalytics from 'components/DatabricksADB/ClusterAnalytics';
import CustomAnalysis from 'components/DatabricksADB/CustomAnalysis';
import DBODashboard from 'components/DatabricksADB/DBODashboard';
import DBsql from 'components/DatabricksADB/DBsql';
import DBSQLCostAnalysis from 'components/DatabricksADB/DBSQLCostAnalysis';
import QueryLevelCostAnalysis from 'components/DatabricksADB/QueryLevelCostAnalysis';
import ResourceUtilizationAnalysis from 'components/DatabricksADB/ResourceUtilizationAnalysis';
import StandardizationMetric from 'components/DatabricksADB/StandardizationMetric';
import LongRunningJobsPage from 'components/DatabricksADB/LongRunningJobsPage';
import OverProvisionedTablePage from 'components/DatabricksADB/OverProvisionedTablePage';
import UntaggedListTablePage from 'components/DatabricksADB/UntaggedListTablePage';
import DBRVersionListTablePage from 'components/DatabricksADB/DBRVersionListTablePage';
import OverallCostTable from 'components/DatabricksADB/OverallCostTable';
import OverallCostDetailsPage from 'components/DatabricksADB/OverallCostDetailsPage';
import RuntimeTablePage from 'components/DatabricksADB/RunTimeTableWS';
import TotalDBUTable from 'components/DatabricksADB/TotalDBUTable';
import ActiveWsTable from 'components/DatabricksADB/ActiveWsTable';
import AutoTermPage from 'components/DatabricksADB/AutoTermPage';
import StarterWarehousePage from 'components/DatabricksADB/StarterWarehouses';
import CostManagementFinancialAnalysis from 'components/DatabricksADB/CostManagementFinancialAnalysis';
import TotalDBUDetails from 'components/DatabricksADB/TotalDBUDetails';
import ComputeCostDetails from 'components/DatabricksADB/ComputeCost';
import ComputeCostTable from 'components/DatabricksADB/ComputeCostTable';
import ComputeCountTable from 'components/DatabricksADB/ComputeCountTable';
import ComputeCountDetails from 'components/DatabricksADB/ComputeCount';
import ComputeSpendTable from 'components/DatabricksADB/ComputeSpend';
import CostVsWorkspaceWithRuntimeTable from 'components/DatabricksADB/CostWorkspaceWithRuntimeTable';
import DbuVsWorkspaceWithRuntimeTable from 'components/DatabricksADB/DbuVsWorkspaceWithRuntimeTable';
import TopSpendTable from 'components/DatabricksADB/TopSpend';
import ClusterCountTable from 'components/DatabricksADB/ClusterCountTable';
import CostSpendTable from 'components/DatabricksADB/CostSpendTable';
import FailedJobCost from 'components/DatabricksADB/FailedJobCost';
import FailedJobCostDetails from 'components/DatabricksADB/FailedJobCostDetails';
import FailureReason from 'components/DatabricksADB/FailureReasons';
import FailureReasonTable from 'components/DatabricksADB/FailureReasonTable';
import JobStatusCost from 'components/DatabricksADB/JobStatusCount';
import JobStatusTable from 'components/DatabricksADB/JobStatusTable';
import ClusterProvisionedByCategory from 'components/DatabricksADB/ClusterProvisionedByCategory';
import ClusterProvisionedDetailsTable from 'components/DatabricksADB/ClusterProvisionedDetailsTable';
import ClusterSpinsUpDetailsTable from 'components/DatabricksADB/ClusterSpinsUpDetailsTable';
import ClusterSpinsUpByCategory from 'components/DatabricksADB/ClusterSpinsUpByCategory';
import PeakHourTable from 'components/DatabricksADB/PeakHourTable';
import ClusterCountWithoutAutoTermination from 'components/DatabricksADB/ClusterCountWithoutAutoTermination';
import CostClusterWithoutAutoTermination from 'components/DatabricksADB/CostClusterWithoutAutoTermination';
import TopTenClusterCostJob from 'components/DatabricksADB/TopTenClusterCostJob';
import TopTenClusterCostInteractive from 'components/DatabricksADB/TopTenClusterCostInteractive';
import ADBTimeRangeView from 'components/DatabricksADB/ADBTimeRangeView';
import PeakHourDetails from 'components/DatabricksADB/PeakHourDetails';
import SQLDetailsPage from 'components/DatabricksADB/SQLDetailsPage';
import DBRTabTable from 'components/DatabricksADB/DBRTabTable';
const DatabricksADBRoutes = [
    {
        key: 'data_bri_wokspac',
        route: '/databricksADB/workspace',
        component: (
            <PrivateRoute
                Component={Workspace}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_jobsADB',
        route: '/databricksADB/jobsADB',
        component: (
            <PrivateRoute
                Component={JobsADB}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_clus_analy',
        route: '/databricksADB/clusteranalytics',
        component: (
            <PrivateRoute
                Component={ClusterAnalytics}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_databri_obs',
        route: '/databricksADB/dbodashboard',
        component: (
            <PrivateRoute
                Component={DBODashboard}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_databri_obs_db_cost',
        route: '/databricksADB/dbSQLCostAnalysis',
        component: (
            <PrivateRoute
                Component={DBSQLCostAnalysis}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_databri_obs_query_cost',
        route: '/databricksADB/queryLevelCostAnalysis',
        component: (
            <PrivateRoute
                Component={QueryLevelCostAnalysis}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_databri_obs_resource_util',
        route: '/databricksADB/resourceUtilizationAnalysis',
        component: (
            <PrivateRoute
                Component={ResourceUtilizationAnalysis}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_databri_obs_standardization_metric',
        route: '/databricksADB/standardizationMetric',
        component: (
            <PrivateRoute
                Component={StandardizationMetric}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cust_analy',
        route: '/databricksADB/customanalysis',
        component: (
            <PrivateRoute
                Component={CustomAnalysis}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_dbsql_perfom',
        route: '/databricksADB/dbsqlperfomance',
        component: (
            <PrivateRoute
                Component={DBsql}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_auto_term',
        route: '/databricksADB/autoTerm',
        component: (
            <PrivateRoute
                Component={AutoTermPage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_starter_warehouse',
        route: '/databricksADB/starterWarehouse',
        component: (
            <PrivateRoute
                Component={StarterWarehousePage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_long_running_jobs',
        route: '/databricksADB/long-running-jobs',
        component: (
            <PrivateRoute
                Component={LongRunningJobsPage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_over_provisioned',
        route: '/databricksADB/over-provisioned',
        component: (
            <PrivateRoute
                Component={OverProvisionedTablePage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_untag_list',
        route: '/databricksADB/untagged-list',
        component: (
            <PrivateRoute
                Component={UntaggedListTablePage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_dbr_ver_list',
        route: '/databricksADB/dbr-version-list',
        component: (
            <PrivateRoute
                Component={DBRVersionListTablePage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_dbr_tab_table',
        route: '/databricksADB/dbr-tab-table',
        component: (
            <PrivateRoute
                Component={DBRTabTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_over_all_cost',
        route: '/databricksADB/overall-cost',
        component: (
            <PrivateRoute
                Component={OverallCostTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_over_all_cost_details',
        route: '/databricksADB/overall-cost/details',
        component: (
            <PrivateRoute
                Component={OverallCostDetailsPage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_run_time_table',
        route: '/databricksADB/runTime_table',
        component: (
            <PrivateRoute
                Component={RuntimeTablePage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cost_workspace_run_time_table',
        route: '/databricksADB/costVsworkspaceRunTimeTable',
        component: (
            <PrivateRoute
                Component={CostVsWorkspaceWithRuntimeTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_dbu_workspace_run_time_table',
        route: '/databricksADB/dbuVsworkspaceRunTimeTable',
        component: (
            <PrivateRoute
                Component={DbuVsWorkspaceWithRuntimeTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cluster_count_table',
        route: '/databricksADB/clusterCount_table',
        component: (
            <PrivateRoute
                Component={ClusterCountTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cost_spend_table',
        route: '/databricksADB/cost_spend_table',
        component: (
            <PrivateRoute
                Component={CostSpendTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cluster_provisioned_by_category',
        route: '/databricksADB/cluster_provisioned_by_category',
        component: (
            <PrivateRoute
                Component={ClusterProvisionedByCategory}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cluster_provisioned_by_category_details',
        route: '/databricksADB/clusterProvisionedByCategory_details',
        component: (
            <PrivateRoute
                Component={ClusterProvisionedDetailsTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cluster_spinsup_by_category',
        route: '/databricksADB/cluster_spinsup_by_category',
        component: (
            <PrivateRoute
                Component={ClusterSpinsUpByCategory}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_clusterCount_without_autoTermination',
        route: '/databricksADB/clusterCountWithoutAutoTermination',
        component: (
            <PrivateRoute
                Component={ClusterCountWithoutAutoTermination}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_costCluster_without_autoTermination',
        route: '/databricksADB/costClusterWithoutAutoTermination',
        component: (
            <PrivateRoute
                Component={CostClusterWithoutAutoTermination}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_top10_cluster_cost_job',
        route: '/databricksADB/topTenClusterCost_job',
        component: (
            <PrivateRoute
                Component={TopTenClusterCostJob}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_top10_cluster_cost_interactive',
        route: '/databricksADB/topTenClusterCost_interactive/',
        component: (
            <PrivateRoute
                Component={TopTenClusterCostInteractive}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cluster_spinsup_by_category_details',
        route: '/databricksADB/clusterSpinsupByCategory_details',
        component: (
            <PrivateRoute
                Component={ClusterSpinsUpDetailsTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_active_workspaces',
        route: '/databricksADB/active-workspaces',
        component: (
            <PrivateRoute
                Component={ActiveWsTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_total_dbus',
        route: '/databricksADB/total-dbu',
        component: (
            <PrivateRoute
                Component={TotalDBUTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_cost_management',
        route: '/databricksADB/costmanagement',
        component: (
            <PrivateRoute
                Component={CostManagementFinancialAnalysis}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_total_dbus_details',
        route: '/databricksADB/total-dbu/details',
        component: (
            <PrivateRoute
                Component={TotalDBUDetails}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_compute_cost_details',
        route: '/databricksADB/compute-cost-details',
        component: (
            <PrivateRoute
                Component={ComputeCostDetails}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_compute_cost_details_table',
        route: '/databricksADB/Cost/detail_table',
        component: (
            <PrivateRoute
                Component={ComputeCostTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_compute_count_details',
        route: '/databricksADB/compute-count-details',
        component: (
            <PrivateRoute
                Component={ComputeCountDetails}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_compute_count_details_table',
        route: '/databricksADB/Count/detail_table',
        component: (
            <PrivateRoute
                Component={ComputeCountTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_compute_spend_details_table',
        route: '/databricksADB/compute-spend-details',
        component: (
            <PrivateRoute
                Component={ComputeSpendTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_top_spending_workspace',
        route: '/databricksADB/top-spending-workspace',
        component: (
            <PrivateRoute
                Component={TopSpendTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_failed_jobs_cost',
        route: '/databricksADB/failed-jobs-cost',
        component: (
            <PrivateRoute
                Component={FailedJobCost}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_failed_jobs_cost_details',
        route: '/databricksADB/failed-jobs-cost-details',
        component: (
            <PrivateRoute
                Component={FailedJobCostDetails}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_status_overview_cost',
        route: '/databricksADB/statusOverview-cost',
        component: (
            <PrivateRoute
                Component={JobStatusCost}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_status_overview_table',
        route: '/databricksADB/statusOverview/detail_table',
        component: (
            <PrivateRoute
                Component={JobStatusTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_failure_reasons',
        route: '/databricksADB/FailureReasons',
        component: (
            <PrivateRoute
                Component={FailureReason}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_failure_reasons-table',
        route: '/databricksADB/FailureReasonsTable',
        component: (
            <PrivateRoute
                Component={FailureReasonTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_peak_hour_table',
        route: '/databricksADB/peakHourDetails',
        component: (
            <PrivateRoute
                Component={PeakHourTable}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_performance_dashboard',
        route: '/databricksADB/performance-dashboard',
        component: (
            <PrivateRoute
                Component={ADBTimeRangeView}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_peak_hour_details',
        route: '/databricksADB/peak-hour-details',
        component: (
            <PrivateRoute
                Component={PeakHourDetails}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },
    {
        key: 'data_bri_peak_sql_details',
        route: '/databricksADB/SQLDetails',
        component: (
            <PrivateRoute
                Component={SQLDetailsPage}
                restrictedRoles={[
                    'Data Operations Admin',
                    'Data Operations User',
                    'Program Executive'
                ]}
            />
        )
    },


];

export default DatabricksADBRoutes;
